export default __webpack_public_path__ + "static/media/style.module.65ba2727.less";